module.exports = __webpack_public_path__ + "static/media/designful.fc5f2ed6.png";